import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ResetZoomIcon = (props: IconProps) => (
  <Icon w="20px" h="20px" viewBox="0 0 20 20" {...props}>
    <path d="M1.66669 17.1585L6.07502 12.7502L3.33335 10.0002H10L10 16.6668L7.25835 13.9252L2.84168 18.3335L1.66669 17.1585ZM17.1584 1.66683L12.75 6.07516L10 3.3335V10.0002L16.6667 10.0002L13.925 7.2585L18.3334 2.84183L17.1584 1.66683Z" />
  </Icon>
);

export default memo(ResetZoomIcon);
